import styled from "@react-pdf/styled-components";
import { Font } from "@react-pdf/renderer";
import { checkHasValue } from "utils/general";

// Font.register({
//   family: "ZCool",
//   src:
//     "https://fonts.gstatic.com/s/zcoolkuaile/v7/tssqApdaRQokwFjFJjvM6h2WpozzoXhC2g.ttf",
// });

// Font.register({
//   family: "ChineseFont",
//   src: "/MicrosoftBlack.ttf",
//   // src: "/Noto_Sans_TC/static/NotoSansTC-Black.ttf",
// });

export const Page = styled.Page`
  padding: 35px 30px;
`;

export const Row = styled.View`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const Col = styled.View`
  width: ${(props) => props.width || "auto"};
  margin-bottom: 10px;
`;

export const Divider = styled.View`
  width: 100%;
  height: 1px;
  background-color: #c6c6c6;
  margin: 8px 0px 20px;
`;

export const SectionContainer = styled.View`
  border: ${(props) => (props.bordered ? "1px #e1e1e1" : "none")};
  margin-bottom: ${(props) => props.marginBottom || "15px"};
`;

export const SectionTitleContainer = styled.View`
  background-color: #eaecee;
  margin-bottom: 5px;
  padding: 5px;
`;

export const SectionTitle = styled.Text`
  color: #212f3d;
  font-size: 10px;
  margin: 5px;

  font-family: "ChineseFont";
`;

export const SectionContentContainer = styled(Row)`
  padding: 5px 10px;
`;

export const Label = styled.Text`
  width: ${(props) => props.width || "50%"};
  color: #4e4e4e;
  font-size: 10px;
  margin-right: ${(props) => props.marginRight || "0"};

  font-family: "ChineseFont";
`;

export const Text = styled.Text`
  color: ${(props) =>
    checkHasValue(props.isInRange) && !props.isInRange ? "red" : "#4e4e4e"};
  font-size: 10px;
  width: ${(props) => props.width || "auto"};
  text-align: ${(props) => props.center && "center"};
  margin: ${(props) => props.margin || "0"};
`;

export const Desc = styled.Text`
  color: #949494;
  font-size: 9px;
  width: 40%;

  font-family: "ChineseFont";
`;

export const FooterRight = styled.Text`
  color: #4e4e4e;
  font-size: 9px;
  position: absolute;
  bottom: 20px;
  right: 30px;
`;

export const FooterLeft = styled.Text`
  color: #4e4e4e;
  font-size: 9px;
  position: absolute;
  bottom: 20px;
  left: 30px;
`;

export const CoverTitle = styled.Text`
  color: black;
  font-size: 24px;
  margin-bottom: 10px;
  text-align: center;

  font-family: "ChineseFont";
`;

export const CoverContainer = styled.View`
  margin-top: 60px;
  text-align: center;
`;

export const CoverSection = styled.View`
  margin-top: 50px;
`;

export const CoverText = styled.Text`
  font-size: 12px;
  font-weight: bold;

  font-family: "ChineseFont";
`;

export const TableColumnTitle = styled(Text)`
  color: #262626;
  font-weight: normal;
  margin-bottom: 8px;

  font-family: "ChineseFont";
`;

export const TableColumnTitleContainer = styled.View`
  padding-bottom: 5px;
  border-bottom-width: 1px;
  border-bottom-color: #8e8e8e;
`;

export const PageTitleContainer = styled.View`
  height: 20px;
  border-bottom-width: 1px;
  border-bottom-color: black;
  margin-bottom: 5px;
`;

export const PageTitleText = styled.Text`
  color: black;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 3px;

  font-family: "ChineseFont";
`;

export const PageTitleIndexContainer = styled.View`
  display: content;
  height: 20px;
  width: auto;
  background-color: black;
  margin-bottom: 3px;
`;

export const PageTitleIndexText = styled.Text`
  color: white;
  font-size: 10px;
  margin: auto;
  padding: 0 3px;
`;
